import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { fetchBusinessesByName, fetchBusinessesById } from '../../actions/businesses_all'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css'

const MIN_VALUE_LENGTH_TO_FETCH = 2

export const BusinessFilterRedux = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [options, setOptions] = useState([])
  const ref = useRef()
  const requestId = useRef(0)

  const handleSearch = async (query) => {
    if (query.length > MIN_VALUE_LENGTH_TO_FETCH) {
      const currentRequest = ++requestId.current
      setIsLoading(true)
      const { response } = await props.fetchBusinessesByName(query)
      // A newer keystroke has fired since this request started; its response is
      // authoritative, so drop this (now stale) one to avoid clobbering it.
      if (currentRequest !== requestId.current) {
        return
      }
      const { results } = response
      let options = []
      if (props.filterInvester) {
        options = results
          .filter((i) => i.parent_business === null)
          .map((i) => ({
            name: i.name,
            value: i.id,
          }))
      } else {
        options = results.map((i) => ({
          name: i.name,
          value: i.id,
        }))
      }

      setOptions(options)
      setIsLoading(false)
    }
  }

  const onChange = (event) => {
    if (event.length) {
      const [{ value }] = event
      props.updateBusinessFilter(value)
    }
  }

  const onInputChange = (value) => {
    if (!value) {
      props.updateBusinessFilter()
    }
  }
  useEffect(() => {
    if (props.businessFilter) {
      props.fetchBusinessesById(props.businessFilter).then(({ response }) => {
        if (ref.current) {
          let event = new Event('input', { bubbles: true })
          ref.current.clear()
          ref.current.setState({ text: response.name })
          ref.current.props.onInputChange(response.name, event)
        }
      })
    }
  }, [props.businessFilter])

  const filterBy = () => true
  return (
    <AsyncTypeahead
      id={'business-filter'}
      onChange={onChange}
      onInputChange={onInputChange}
      filterBy={filterBy}
      isLoading={isLoading}
      minLength={3}
      onSearch={handleSearch}
      options={options}
      placeholder='Type a business name'
      labelKey='name'
      useCache={false}
      ref={ref}
    />
  )
}

const mapStateToProps = (state) => ({
  businesses: state.businessesAll.businesses,
  businessFilter: state.businessFilter.businessFilter,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchBusinessesByName,
      fetchBusinessesById,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessFilterRedux))
